import { memo, useRef, useEffect } from 'react'
import * as Styled from './styled'

interface ITrackItemWrapperProps {
  children: React.ReactNode
  isActive: boolean
  isDisabled?: boolean
  className?: string
  isResizeBtnsVisible?: boolean
  selectedBorderColor: string
  selectedBorderSize?: number
  onLeftResize: (e: MouseEvent | TouchEvent) => void
  onRightResize: (e: MouseEvent | TouchEvent) => void
}

const TrackItemWrapper = ({
  children,
  isActive,
  isDisabled,
  className = '',
  onLeftResize,
  onRightResize,
  isResizeBtnsVisible = true,
  selectedBorderColor,
  selectedBorderSize = 2
}: ITrackItemWrapperProps) => {
  const leftResizeButtonRef = useRef<HTMLDivElement>(null)
  const rightResizeButtonRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const leftButton = leftResizeButtonRef.current
    const rightButton = rightResizeButtonRef.current
    if (leftButton && rightButton) {
      leftButton.addEventListener('mousedown', onLeftResize)
      rightButton.addEventListener('mousedown', onRightResize)
      leftButton.addEventListener('touchstart', onLeftResize, {
        passive: false
      })
      rightButton.addEventListener('touchstart', onRightResize, {
        passive: false
      })
    }
    return () => {
      if (leftButton && rightButton) {
        leftButton.removeEventListener('mousedown', onLeftResize)
        rightButton.removeEventListener('mousedown', onRightResize)
        leftButton.removeEventListener('touchstart', onLeftResize)
        rightButton.removeEventListener('touchstart', onRightResize)
      }
    }
  }, [onLeftResize, onRightResize, leftResizeButtonRef, rightResizeButtonRef])

  return (
    <>
      {children}
      {isActive ? (
        <Styled.TrackItemWrapper
          className={className}
          $selectedBorderColor={selectedBorderColor}
          $borderSize={selectedBorderSize}
        >
          {isResizeBtnsVisible && (
            <>
              <Styled.ResizeButton
                ref={leftResizeButtonRef}
                className="resize-button"
                $side="left"
                $disabled={isDisabled}
                $selectedBorderColor={selectedBorderColor}
              >
                <Styled.ResizeButtonLine className="resize-button-line" />
              </Styled.ResizeButton>
              <Styled.ResizeButton
                ref={rightResizeButtonRef}
                className="resize-button"
                $side="right"
                $disabled={isDisabled}
                $selectedBorderColor={selectedBorderColor}
              >
                <Styled.ResizeButtonLine className="resize-button-line" />
              </Styled.ResizeButton>
            </>
          )}
        </Styled.TrackItemWrapper>
      ) : null}
    </>
  )
}

export default memo(TrackItemWrapper)
